<div class="form-wrapper">
  <span
    [ngClass]="[currentNumber && currentNumber.phonePrefix ? ('flag-icon-' + currentNumber.countryCode.toLowerCase()) : 'd-none']"
    class="pull-left centred-vertical selected-flag flag-icon flag"></span>

  <mat-form-field>
    <mat-select [formControl]="formControl"
                placeholder="Choose"
                (selectionChange)="onSelectionChanged()"
                [(ngModel)]="currentNumber"
                class="width-56">
      <ngx-mat-select-search
        [formControl]="countryFilter"
        [placeholderLabel]="'SEARCH' | translate"
        [noEntriesFoundLabel]="'NO_RESULT'| translate"
        clearSearchInput="true"></ngx-mat-select-search>
      <mat-select-trigger>
        <div class="w-full over-hide text-ellipsis d-flex align-item-center">
        <span
          [ngClass]="[currentNumber? ('flag-icon-' + currentNumber.countryCode.toLowerCase()): 'd-none']"
          class="pull-left flag-icon flag csetCountryLinkentred-vertical"></span>
          <span class="pull-left selected-value" *ngIf="currentNumber">{{currentNumber.countryName}}</span>
        </div>
      </mat-select-trigger>
      <mat-option *ngFor="let country of filteredNumbers | async" [value]="country">
        <div class="w-full over-hide text-ellipsis d-flex align-item-center">
        <span
          [ngClass]="[country.phonePrefix.length > 0 ? ('flag-icon-' + country.countryCode.toLowerCase()): 'd-none']"
          class="pull-left flag-icon flag centred-vertical"></span>
          <span class="pull-left p-l-1">{{country.countryName}}</span>
        </div>
      </mat-option>
    </mat-select>

  </mat-form-field>
</div>
